// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1L_dw","rootSmall":"AddTileButton_rootSmall__3KUN0"};